import Cookies from 'js-cookie';

export const VatType = {
  SELECTION: 'selection',
  YES: 'yes',
  NO: 'no',
};

/** @return {boolean} */
export function isVatUndefined() {
  const vatPriceSelection = Cookies.get('hasVatPriceSelection');
  const type = Cookies.get('isVatPage');

  return !type || (type === VatType.SELECTION && vatPriceSelection == null);
}

/** @return {boolean} */
export function isVatActive() {
  const vatPriceSelection = Cookies.get('hasVatPriceSelection');
  const type = Cookies.get('isVatPage');

  return type === VatType.YES || vatPriceSelection === 'consumer';
}
